import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Slides from '@ifeng/ui_pc_slides';
import { formatImage, formatUrl } from '@ifeng/public_method';
import { getFLiveData } from '../../../../../../services/indexApi';
import { oneChangeTwoDimensional } from '../../../../../../utils/utils';
import { rel } from '../../../../../../utils/rel';

class FLive extends React.PureComponent {
    static propTypes = {
        ad: PropTypes.object,
    };

    state = {
        data: [],
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        try {
            const data = await getFLiveData();
            const sliceData = data.slice(0, 4);

            this.setState({ data: sliceData });
        } catch (e) {
            console.error(e);
        }

        try {
            const { ad } = this.props;
            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert);
        } catch (e) {
            console.error(e);
        }

        try {
            this.event.trigger('init');
        } catch (e) {
            console.error(e);
        }
    }

    isLive = time => {
        const now = +new Date();
        const endtime = Number(time) * 1000;
        const timeStep = endtime - now;

        return timeStep > 0;
    };

    /* eslint-disable no-confusing-arrow */
    sliderTmpl = itemOut =>
        itemOut.type === 'ad' ? (
            <div ref={itemOut.ref} />
        ) : (
            itemOut.map((item, index) => (
                <div className={styles.slideItem} key={index}>
                    <a
                        className={styles.blockA}
                        href={item.url}
                        target="_blank"
                        alt={item.title}
                        title={item.title}
                        rel={rel}>
                        <div className={styles.imgWrap}>
                            <img src={item.img} className={styles.img} />
                        </div>
                        <span className={this.isLive(item.endtime) ? styles.live : styles.preLook}>
                            {this.isLive(item.endtime) ? '直播中' : '回看'}
                        </span>
                    </a>
                    <div className={styles.title_wrap}>
                        <a href={item.url} target="_blank" alt={item.title} title={item.title} rel={rel}>
                            {item.title}
                        </a>
                    </div>
                </div>
            ))
        );
    /* eslint-enable no-confusing-arrow */

    render() {
        const { data } = this.state;

        const liveData = data.filter(item => item.type !== 'ad');
        const adData = data.filter(item => item.type === 'ad');
        const newData = liveData.length > 0 ? oneChangeTwoDimensional(liveData.slice(0, 4), 2).concat(adData) : adData;

        const sliderConfig = {
            arrows: true,
            autoplay: true,
            dots: true,
            dotsAction: 'hover',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            speed: 300,
            infinite: true,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div id="flive" className={styles.ActionLeague}>
                <div className={styles.title}>
                    <a href="//zhibo.ifeng.com" target="_blank" alt="风直播" title="风直播" rel={rel}>
                        风直播
                    </a>
                </div>
                <Slides content={newData} config={sliderConfig} />
            </div>
        );
    }
}

export default errorBoundary(FLive);
